<script>
  import { cdnresources } from '@/util/config'
  export default {
    name: 'CustomerService',
    data() {
      return {
        cdnresources
      }
    },
    methods: {
      goCustomer(type) {
        switch (type) {
          case '2021':
            window.location.href =
              'https://im3f7eb39.7x24cc.com/phone_webChat.html?accountId=N000000034879&chatId=f114ccbf-1a43-49b6-ac68-7747dc98f738'
            break
          case '2022':
            window.location.href =
              'https://im3f7eb39.7x24cc.com/phone_webChat.html?accountId=N000000034879&chatId=fc5eec3e-a475-4ef3-88e0-c58fb3f5c20c'
            break
          case '2023':
            window.location.href =
              'https://im3f7eb39.7x24cc.com/phone_webChat.html?accountId=N000000034879&chatId=b0d0917c-0165-44f3-a1fd-468abde0c50b'
            break
        }
      }
    }
  }
</script>
<template>
  <div class="customer-service">
    <img
      class="banner"
      :src="cdnresources + '/prod/images/xiangaibao/CustomerServiceBanner.png'"
    />
    <div class="content">
      <img
        class="banner"
        @click="goCustomer('2021')"
        :src="cdnresources + '/prod/images/xiangaibao/herf2021.png'"
      />
      <img
        class="banner"
        @click="goCustomer('2022')"
        :src="cdnresources + '/prod/images/xiangaibao/herf2022.png'"
      />
      <img
        class="banner"
        @click="goCustomer('2023')"
        :src="cdnresources + '/prod/images/xiangaibao/herf2023.png'"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .customer-service {
    font-size: 16px;
    .banner {
      width: 100%;
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: xvw(126);
      .banner {
        width: xvw(577);
        margin-bottom: xvw(45);
      }
    }
  }
</style>
